/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import styled from 'styled-components';
import { Typography } from '@one-thd/sui-atomic-components';
import { Divider } from './styles';
import { currencyStringFormat } from '../../utils/format';

const LineItemContainer = styled.div`
  div:last-child {
    div:last-child {
      margin-bottom: 0 !important;
    }
  }
`;

const MeasureItemsList = ({ measuresList, hasRegionalInstallPrice, regionalInstallPrice }) => {
  let massagedMeasuresList = measuresList;
  if (hasRegionalInstallPrice !== null && regionalInstallPrice > 0) {
    massagedMeasuresList = cloneDeep(measuresList);
    let sqfTotal = massagedMeasuresList.reduce(function (prev, cur) {
      return prev + cur.sqFt;
    }, 0);
    massagedMeasuresList.map((measure) => {
      const { sqFt, totalPrice } = measure;
      measure.totalPrice = totalPrice + (sqFt / sqfTotal) * regionalInstallPrice;
    });
  }
  return isEmpty(massagedMeasuresList) ? null : (
    <>
      <hr className="divider" />
      <LineItemContainer>
        {massagedMeasuresList.map((measure, key) => {
          const { room: roomName, sqFt, totalPrice, unit = 'sq. ft.' } = measure;
          return (
            <div key={`${key}roomItem`}>
              <div style={{ display: 'flex' }}>
                <Typography variant="h4" align="left" weight="bold" style={{ flexGrow: '1' }}>
                  {roomName}
                </Typography>
                {totalPrice > 0 &&
                  <Typography paragraph align="right">{`$${currencyStringFormat(totalPrice)}`}</Typography>}
              </div>
              <div style={{ marginBottom: '16px' }}>
                <Typography paragraph>{sqFt.toLocaleString('en-EN')}&nbsp;{unit}</Typography>
              </div>
            </div>
          );
        })}
      </LineItemContainer>
    </>
  );
};

MeasureItemsList.propTypes = {
  measuresList: PropTypes.arrayOf(PropTypes.shape({
    carpetPadPrice: PropTypes.string,
    id: PropTypes.string,
    length: PropTypes.number,
    padPrice: PropTypes.number,
    price: PropTypes.number,
    room: PropTypes.string,
    sqFt: PropTypes.number,
    squarePrice: PropTypes.string,
    totalPrice: PropTypes.number,
    width: PropTypes.number,
  })).isRequired,
  hasRegionalInstallPrice: PropTypes.number.isRequired,
  regionalInstallPrice: PropTypes.number.isRequired
};

export default MeasureItemsList;
